import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'center',
    gap: 0,
    padding: '4px',
    flexWrap: 'wrap' as const,
    minHeight: 'fit-content',
    '@media (max-width: 768px)': {
      gap: 2,
      padding: '2px',
    },
  },
  visualizerContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 0,
    '@media (max-width: 768px)': {
      marginBottom: 0,
    },
  },
  messagesContainer: {
    flex: 1,
    minWidth: 280,
    maxWidth: '100%',
    position: 'relative',
    height: '300px',
    minHeight: '300px',
    '@media (max-width: 768px)': {
      minWidth: '100%',
      height: '250px',
      minHeight: '250px',
    },
  },
});
